"use strict"

import angular from "angular"

export class RateLimitMessageComponent {
  /*@ngInject*/
  constructor($scope, $timeout) {
    this.$scope = $scope
    this.$timeout = $timeout
    this.showMessage = false
    this.message = ""
    this.activeSessions = 0
    this.maxSessions = 0
  }

  $onInit() {
    // Listen for rate limit events from the interceptor
    this.$scope.$on("gemapark-rate-limit", (event, data) => {
      this.showRateLimitMessage(data)
    })
  }

  showRateLimitMessage(data) {
    this.message = data.message || "Sorry the system is very busy just now, please try again later"
    this.activeSessions = data.activeSessions || 0
    this.maxSessions = data.maxSessions || 20
    this.showMessage = true

    // Auto-hide after 10 seconds
    this.$timeout(() => {
      this.hideMessage()
    }, 10000)
  }

  hideMessage() {
    this.showMessage = false
    this.message = ""
  }

  retry() {
    this.hideMessage()
    // You could add retry logic here if needed
    // For now, just hide the message and let user try again
  }
}

export default angular.module("components.rateLimitMessage", []).component("rateLimitMessage", {
  template: require("./rateLimitMessage.html"),
  controller: RateLimitMessageComponent,
  bindings: {},
}).name
